const homePath = '/app/audiences';

export { homePath };
